import React, { useCallback, useEffect, useState } from 'react';
import { dersLabel } from '../../lib/dersler';
import { puanSeviyeAdi } from '../../lib/zorlukSeviye';
import MusteriSoruKarti from './MusteriSoruKarti';

/**
 * Sepet (2026-10-26): kalemler sunucuda (musteri_sepet) — her açılışta görünürlük yeniden denetlenir;
 * bu arada satılan / başka siparişte ayrılan soru `uygun:false` + neden ile gelir. Bağlam grubu birlikte
 * çıkar. "Sipariş oluştur" sunucuda transaction içinde yeniden denetler; çakışmada 409.
 */
export default function MusteriSepet({ api, sepetDegisti, onSiparis }) {
  const [kalemler, setKalemler] = useState(null);
  const [acik, setAcik] = useState(null);
  const [not, setNot] = useState('');
  const [mesgul, setMesgul] = useState(false);
  const [hata, setHata] = useState('');
  const [redler, setRedler] = useState([]);

  // Hata burada SİLİNMEZ: sipariş reddinden sonra sepet yeniden okunurken ret nedeni ekranda kalmalı.
  const yukle = useCallback(async () => {
    try {
      const d = await api.sepet();
      setKalemler(d.kalemler || []);
      sepetDegisti((d.kalemler || []).map((k) => k.soru_no));
    } catch (e) {
      setHata(e.message || 'Sepet alınamadı');
      setKalemler([]);
    }
  }, [api, sepetDegisti]);

  useEffect(() => { yukle(); }, [yukle]);

  const cikar = async (no) => {
    setMesgul(true); setHata('');
    try { await api.sepettenCikar(no); await yukle(); } catch (e) { setHata(e.message); }
    setMesgul(false);
  };
  const bosalt = async () => {
    if (!window.confirm('Sepetteki bütün sorular çıkarılsın mı?')) return;
    setMesgul(true); setHata('');
    try { await api.sepetiBosalt(); await yukle(); } catch (e) { setHata(e.message); }
    setMesgul(false);
  };
  const siparisVer = async () => {
    setMesgul(true); setHata(''); setRedler([]);
    try {
      const d = await api.siparisVer(not.trim());
      setNot('');
      sepetDegisti([]);
      setKalemler([]);
      onSiparis(d);
    } catch (e) {
      setHata(e.message || 'Sipariş oluşturulamadı');
      if (e.govde && Array.isArray(e.govde.red)) setRedler(e.govde.red);
      await yukle();
    }
    setMesgul(false);
  };

  if (kalemler === null) return <div className="py-8 text-center text-sm text-gray-400">Sepet yükleniyor…</div>;
  const uygunDegil = kalemler.filter((k) => !k.uygun);

  return (
    <div className="space-y-3">
      {hata && <div data-sepet-hata className="p-3 rounded-lg border border-red-300 bg-red-50 text-sm text-red-700">{hata}</div>}
      {redler.length > 0 && (
        <ul className="p-3 rounded-lg border border-orange-200 bg-orange-50 text-xs text-orange-900 list-disc ml-0 pl-6">
          {redler.map((r) => <li key={r.public_no}>#{r.public_no}: {r.neden}</li>)}
        </ul>
      )}
      {kalemler.length === 0 ? (
        <div data-sepet-bos className="p-8 text-center text-sm text-gray-500 bg-white rounded-xl border border-gray-200">
          Sepetiniz boş. "Sorular" sekmesinden soru ekleyebilirsiniz.
        </div>
      ) : (
        <>
          <div className="bg-white border border-gray-200 rounded-xl overflow-hidden">
            <table className="w-full text-sm">
              <thead className="bg-gray-50 text-xs text-gray-500">
                <tr>
                  <th className="text-left px-3 py-2">No</th>
                  <th className="text-left px-3 py-2">Ders / konu</th>
                  <th className="text-left px-3 py-2">Kod</th>
                  <th className="text-left px-3 py-2">Seviye</th>
                  <th className="text-left px-3 py-2">Durum</th>
                  <th className="text-right px-3 py-2">İşlem</th>
                </tr>
              </thead>
              <tbody>
                {kalemler.map((k) => (
                  <React.Fragment key={k.soru_no}>
                    <tr data-sepet-kalem={k.soru_no} className={`border-t border-gray-100 ${k.uygun ? '' : 'bg-orange-50'}`}>
                      <td className="px-3 py-2 font-mono font-semibold">#{k.soru_no}</td>
                      <td className="px-3 py-2 text-gray-700">{k.ders ? dersLabel(k.ders) : '—'}{k.konu ? ` · ${k.konu}` : ''}</td>
                      <td className="px-3 py-2 font-mono text-xs text-gray-500">{k.kazanim_kodu || '—'}</td>
                      <td className="px-3 py-2 text-xs">{puanSeviyeAdi(k.zorluk_puan) || '—'}</td>
                      <td className="px-3 py-2 text-xs">{k.uygun ? <span className="text-green-700">seçilebilir</span> : <span className="text-orange-800">⚠ {k.neden}</span>}</td>
                      <td className="px-3 py-2 text-right whitespace-nowrap">
                        {k.soru_metni_latex && (
                          <button type="button" onClick={() => setAcik(acik === k.soru_no ? null : k.soru_no)} className="text-xs text-blue-600 hover:underline mr-3">
                            {acik === k.soru_no ? 'Kapat' : 'Göster'}
                          </button>
                        )}
                        <button type="button" data-sepetten-cikar={k.soru_no} disabled={mesgul} onClick={() => cikar(k.soru_no)}
                          className="text-xs text-red-600 hover:underline disabled:opacity-50">Çıkar</button>
                      </td>
                    </tr>
                    {acik === k.soru_no && (
                      <tr><td colSpan={6} className="px-3 py-3 bg-gray-50"><MusteriSoruKarti soru={k} api={api} /></td></tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
          <div className="bg-white border border-gray-200 rounded-xl p-3 space-y-2">
            <label className="block text-xs text-gray-600">
              Sipariş notu (isteğe bağlı)
              <textarea value={not} maxLength={1000} onChange={(e) => setNot(e.target.value)} rows={2}
                className="mt-1 w-full px-2 py-1.5 rounded border border-gray-300 text-sm" placeholder="Ör. teslim tarihi, kullanılacak yayın" />
            </label>
            {uygunDegil.length > 0 && (
              <div className="text-xs text-orange-800">Seçilemeyen {uygunDegil.length === 1 ? 'bir soru' : 'sorular'} var — sipariş için önce sepetten çıkarın.</div>
            )}
            <div className="flex flex-wrap gap-2">
              <button type="button" data-siparis-olustur disabled={mesgul || uygunDegil.length > 0} onClick={siparisVer}
                className="px-4 py-2 rounded-lg bg-green-600 text-white text-sm font-semibold hover:bg-green-700 disabled:opacity-50">
                Sipariş oluştur
              </button>
              <button type="button" disabled={mesgul} onClick={bosalt}
                className="px-3 py-2 rounded-lg border border-gray-300 text-sm text-gray-600 hover:bg-gray-50 disabled:opacity-50">Sepeti boşalt</button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
